import React from 'react';
import _ from 'lodash';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Card, CardHeader, Box } from '@mui/material';
//
import { BaseOptionChart } from '../../../../../components/chart';

// ----------------------------------------------------------------------


export const GeneralSalesChart = props => {
  const { data } = props;

  const CHART_DATA = [
    {
      type: 'column',
      name: 'Sprzedaż',
      data: _.map(data, obj => obj.count)
    }
  ];

  const chartOptions = _.merge(BaseOptionChart(), {
    stroke: { width: [0, 2, 3] },
    plotOptions: { bar: { columnWidth: '40%' } },
    fill: { type: ['solid'] },
    labels: _.map(data, obj => obj.date),
    xaxis: { type: 'datetime' },
    tooltip: {
      shared: true,
      intersect: false,
      x: {
        show: true,
        format: 'dd.MM.yyyy'
      }
    }
  });

  return (
    <Card>
      <CardHeader title="Wykres sprzedaży w zależności od czasu" titleTypographyProps={{ variant: 'h4' }} />
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart series={CHART_DATA} options={chartOptions} height={364} />
      </Box>
    </Card>
  );
};
